// Admin Platform managers get their families from the backend (GET /me/access), never from the
// token's customer_scope (spec §2). Holds the latest answer for the signed-in user; accessControl
// reads it, and the family-list refresh writes it.
let current = null;
const listeners = new Set();

export function setOrganizationScope(userId, access) {
  const next = access && access.scopeSource === 'organization'
    ? { userId: String(userId || ''), customerIds: [...new Set((Array.isArray(access.customerIds) ? access.customerIds : []).map(String))].sort() }
    : null;
  if (JSON.stringify(next) === JSON.stringify(current)) return false;
  current = next;
  listeners.forEach((listener) => listener());
  return true;
}

// The organization scope for this user, or null when their scope comes from the token.
export function organizationScopeFor(userId) {
  return current && current.userId === String(userId || '') ? current.customerIds : null;
}

// A signed-out tab has no user to hold a scope for; called on sign-out so a later sign-in
// (the same person or someone else) never sees a stale answer before its own /me/access resolves.
export function clearOrganizationScope() {
  if (current === null) return false;
  current = null;
  listeners.forEach((listener) => listener());
  return true;
}

export function onOrganizationScopeChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
